window.app = window.app || {};

window.app.faqList = {
  items: document.querySelectorAll('.mt-faq-list__items .mt-accordion'),
  btnToggle: document.querySelector('.mt-faq-list__btn-toggle'),

  init: function() {
    const _this = this;
    if (_this.items.length === 0) return;

    _this.items.forEach(item => {
      const summary = item.querySelector('summary');
      summary.addEventListener('click', () => {
        if (item.hasAttribute('open')) return; 
        _this.items.forEach(i => item != i && i.removeAttribute('open'));
      });
    });

    if (_this.btnToggle) {
      _this.btnToggle.addEventListener('click', e => {
        e.preventDefault();
        const btnText = _this.btnToggle.querySelector('span:first-child');

        if (_this.btnToggle.classList.contains('show')) {
          _this.btnToggle.classList.remove('show');
          btnText.innerHTML = _this.btnToggle.dataset.tHide;
          _this.items.forEach(item => item.classList.remove('hidden'));
        } else {
          _this.btnToggle.classList.add('show');
          btnText.innerHTML = _this.btnToggle.dataset.tShow;
          for (let i = 0; i < _this.items.length; i++) {
            if (i >= Number(_this.btnToggle.dataset.default)) {
              _this.items[i].classList.add('hidden');
            }
          }
        }
      });
    }
  }
}
window.app.faqList.init();